import {createStore} from 'vuex'
import {getUserInfo, getPermissions} from "@/api/common";

export default createStore({
    state: {
        menu: [], // 菜单列表
        permission: [], // 权限菜单
        userInfo: null, // 用户信息

        // 全局的loading
        spinning: false,
        spinningCount: 0,

        dict: {}, // 字典项信息
    },
    getters: {},
    mutations: {
        // 设置用户信息
        SET_USERINFO: (state, res) => {
            state.userInfo = res
        },

        // 设置权限菜单
        SET_PERMISSION: (state, res) => {
            state.permission = res
        },

        // 设置菜单信息
        SET_MENU: (state, menus) => {
            state.menu = menus
        },

        // 全局loading
        SET_SPINNING(state, spinning) {
            state.spinning = spinning
        },
        setSpinningCount(state, number) {
            state.spinningCount += number
        },

        SET_DICT(state, {key, value}) {
            let _dict = state.dict
            if (!_dict[key]) {
                _dict[key] = value
            }
            state.dict = _dict
        },
    },
    actions: {
        // 获取用户信息
        getUserInfo({commit}, data) {
            return new Promise((resolve, reject) => {
                getUserInfo().then(res => {
                    if (res.code === 0) {
                        commit('SET_USERINFO', res.data)
                        resolve(true)
                    }
                })
            })
        },

        // 获取用户权限
        getUserPermission({commit}, data) {
            return new Promise((resolve, reject) => {
                getPermissions().then(res => {
                    if (res.code === 0) {
                        commit('SET_PERMISSION', res.data.permissions)
                        commit('SET_MENU', res.data.menus)
                        resolve(true)
                    }
                })
            })

        },

        // 设置字典项
        setDict({commit}, data) {
            commit('SET_DICT', data)
        }
    },
    modules: {}
})
